import type { ReactNode } from 'react'

export type MetricItem = {
  label: string
  value: ReactNode
  note?: string
  emphasis?: boolean
}

export function MetricStrip({ metrics }: { metrics: MetricItem[] }) {
  return (
    <section className="metric-strip" aria-label="CRM overview metrics">
      {metrics.map((metric) => (
        <div className={`metric-item${metric.emphasis ? ' is-emphasis' : ''}`} key={metric.label}>
          <span>{metric.label}</span>
          <strong>{metric.value}</strong>
          {metric.note ? <small>{metric.note}</small> : null}
        </div>
      ))}
    </section>
  )
}
